'use client'

import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { useState } from 'react'
import Image from 'next/image'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { useMediaQuery } from '@segway/core'

import { Arrow } from '@/components'
import { Carousel, CarouselItem } from '@/components'
import { Link } from '@/i18n/navigation'
import { Button } from '@/ui/button/Button'

import { BannerType } from '../types'

import { BannerButton } from './Button'

import styles from './index.module.css'

import '@splidejs/react-splide/css'

interface BanerProps {
  blockData: BannerType
}

interface CarouselProps {
  go: (index: number | string) => void
}

// 不在当前tab网页 记录当前是否视频
const activeIsVideo = false

export default function Banner({ blockData }: BanerProps) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [autoPlay, setAutoPlay] = useState(true)
  // const [isHover, setIsHover] = useState(false)
  const responsive = useMediaQuery()
  // const carouselRef = useRef<CarouselApi>(null)
  const carouselRef1 = useRef<CarouselProps>(null)
  const videoListRef = useRef<HTMLVideoElement[]>([])
  const [bannerIndex, setBannerIndex] = useState(0)
  // 第一个数据为视频的时候，等它加载完
  const [firstVideoLoad, setFirstVideoLoad] = useState(false)
  const bannerTimer = useRef<NodeJS.Timeout>()
  const uuid = useRef(0)

  const isXlScreen = responsive && responsive.xl
  const isMdScreen = responsive && responsive.md

  const bannerTotal = useMemo(() => {
    return blockData?.items?.length || 0
  }, [blockData])

  const playDotsAnimation = useCallback((index: number) => {
    const elems = document.querySelectorAll('.progressLine')
    const len = elems.length
    const r = document.querySelectorAll('.progressLine')[index] as HTMLElement
    let n: number | undefined
    let O = 5000
    if (videoListRef.current[index]) {
      videoListRef.current[index].play()
      O = videoListRef.current[index].duration
    }
    if (!r && len > 1) {
      return
    }
    const s = (Number.isNaN(parseInt(r.style.width)) ? 0 : parseInt(r.style.width)) / 100
    uuid.current = window.requestAnimationFrame(function e(t) {
      if (n === undefined && n !== 0) {
        n = t - O * s
      }
      let a = t - n
      if (videoListRef.current[index]) {
        a = videoListRef.current[index].currentTime
      }
      if (a < O) {
        const o = Math.min((a / O) * 100, 100)
        r.style.width = `${o}%`
        elems.forEach((item, j) => {
          if (index > j) {
            const i = item as HTMLElement
            i.style.width = '100%'
          }
        })
        uuid.current = window.requestAnimationFrame(e)
      } else {
        if (index === len - 1) {
          elems.forEach((item) => {
            const i = item as HTMLElement
            i.style.width = '0%'
          })
        }
        carouselRef1.current?.go('>')
      }
    })
  }, [])

  const handleNext = () => {
    stopDotsAnimation()
    let index = bannerIndex + 1
    if (index > bannerTotal - 1) {
      index = 0
    }
    handleClickDot(index)
  }

  const handlePrev = () => {
    let index = bannerIndex - 1
    if (index < 0) {
      index = bannerTotal - 1
    }
    handleClickDot(index)
  }

  const handleClickDot = (index: number) => {
    if (index === bannerIndex) return
    stopDotsAnimation()
    const elems = document.querySelectorAll('.progressLine')
    elems.forEach((item, j) => {
      const i = item as HTMLElement
      if (index > j) {
        i.style.width = '100%'
      } else {
        i.style.width = '0%'
      }
    })

    carouselRef1.current?.go(index)
  }
  const stopDotsAnimation = () => {
    window.cancelAnimationFrame(uuid.current)
    if (videoListRef.current[activeIndex]) {
      videoListRef.current[activeIndex].pause()
    }
  }

  const handleSideChange = (index: number) => {
    setActiveIndex(index)
    // 视频进度重置为0
    videoListRef.current.map((item) => {
      if (item) {
        item.pause()
        item.currentTime = 0
      }
    })
    playDotsAnimation(index)
  }

  useEffect(() => {
    if (!blockData.items[0].pc.video_url) {
      setFirstVideoLoad(true)
    }
  }, [blockData])

  useEffect(() => {
    if (bannerTimer.current) {
      return
    }

    if (firstVideoLoad) {
      bannerTimer.current = setInterval(() => {
        if (carouselRef1.current) {
          clearInterval(bannerTimer.current)
          playDotsAnimation(0)
        }
      }, 1000)
    }
  }, [playDotsAnimation, firstVideoLoad])

  // 浏览器未浏览当前网页tab时关闭轮播
  useEffect(() => {
    const handlePause = () => {
      if (document.hidden) {
        setAutoPlay(false)
      } else {
        if (activeIsVideo) {
          setAutoPlay(false)
        } else {
          setAutoPlay(true)
        }
      }
    }

    document.addEventListener('visibilitychange', handlePause)

    return () => {
      document.removeEventListener('visibilitychange', handlePause)
    }
  }, [])

  const renderXlBanner = () => {
    return (
      <div
        className={`group relative m-auto mt-[-53px] max-w-[2560px] max-xl:mt-[-40px]`}
        // onMouseEnter={() => handleBannerHover()}
        // onMouseLeave={() => handleBannerLeave()}
      >
        <Splide
          ref={carouselRef1}
          options={{
            type: 'loop',
            // autoplay: true,
            pagination: !1,
            drag: !1,
            arrows: !1,
            rewind: !0,
            perMove: 1,
            // lazyLoad: "nearby",
            preloadPages: 2,
            interval: 5000,
          }}
          onMove={(e: object, a: number) => {
            stopDotsAnimation()
            setBannerIndex(a)
            handleSideChange(a)
          }}>
          {blockData.items.map((_, index) => (
            <SplideSlide
              key={index}
              onMouseEnter={() => {
                stopDotsAnimation()
              }}
              onMouseLeave={() => {
                playDotsAnimation(index)
              }}>
              <Link href={_.pc.link}>
                <div className="relative h-0 w-full pt-[41.4583%]">
                  <div className="absolute top-0 flex h-full w-full flex-col items-center">
                    {_?.pc?.video_url ? (
                      <video
                        ref={(ele) => {
                          if (ele) {
                            videoListRef.current[index] = ele
                          }
                        }}
                        poster={_?.pc?.image}
                        autoPlay={index === 0}
                        src={_?.pc?.video_url}
                        playsInline
                        muted
                        preload="auto"
                        controlsList="nopictureinpicture"
                        onLoadedMetadata={() => {
                          if (index === 0) {
                            setFirstVideoLoad(true)
                          }
                        }}
                        onEnded={(e) => {
                          ;(e.target as HTMLVideoElement).currentTime = 0
                        }}
                        className="absolute h-[100%] w-[100%] object-cover"></video>
                    ) : (
                      <Image priority src={_?.pc?.image} alt={_?.pc?.image_alt} fill />
                    )}
                    <div className="mt-[117.5px]">
                      {/* 主内容 */}
                      <div className="relative flex w-[1000px] flex-col items-center gap-y-2 text-center text-white">
                        {_?.pc?.subtitle && (
                          <div
                            className="text-subtitle w-full overflow-hidden text-ellipsis whitespace-nowrap text-[20px]"
                            style={{ color: _?.pc?.subtitle_color }}
                            title={_?.pc?.subtitle}>
                            {_?.pc?.subtitle}
                          </div>
                        )}
                        {_?.pc?.title && (
                          <div
                            className="text-title w-full overflow-hidden text-ellipsis whitespace-nowrap text-[64px] leading-[77px] max-xl:text-[40px] max-xl:leading-[48px]"
                            style={{ color: _?.pc?.title_color }}
                            title={_?.pc?.title}>
                            {_?.pc?.title}
                          </div>
                        )}
                        {_?.pc?.title_image && (
                          <div className="w-full text-center">
                            <Image
                              src={_?.pc?.title_image}
                              alt={_?.pc?.title || 'Banner title'}
                              className="inline-block h-full w-full max-w-[540px] object-contain"
                              style={{ height: 'auto' }}
                              width={0}
                              height={0}
                              unoptimized
                              sizes="100vw"
                            />
                          </div>
                        )}
                        <div
                          className="text-description mb-4 mt-[0px] w-full text-[28px] leading-[32px] max-xl:text-[16px] max-xl:leading-[22px]"
                          style={{ color: _?.pc?.content_color }}>
                          {_?.pc?.content}
                        </div>
                        {_?.pc?.show_button == '1' ? (
                          <BannerButton data={_?.pc}>
                            <span>{_?.pc?.button_text}</span>
                          </BannerButton>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </SplideSlide>
          ))}
        </Splide>
        {/* 选项卡 */}
        <div className="absolute bottom-0 left-0 h-[100px] w-full bg-[linear-gradient(360deg,rgba(0,0,0,0.5)_-71.82%,rgba(0,0,0,0)_88.64%)]">
          <div className="mx-auto flex w-fit justify-center">
            <div className="flex h-fit items-center justify-center text-[16px] text-white">
              {blockData?.items.map((item, index) => (
                <div
                  key={index}
                  className={`relative flex min-w-[140px] items-center justify-center px-[20px] pt-[15px] text-white ${activeIndex === index ? 'font-miSansSemiBold520 text-opacity-100' : 'text-opacity-60'} cursor-pointer border-t border-gray-4 text-[18px]`}
                  onClick={() => {
                    handleClickDot(index)
                  }}>
                  {/* activeprogressbar: 图片进度条动画 */}
                  <div
                    className={`progressLine absolute left-0 top-[-1px] h-[1px] w-0 bg-white ${!blockData.items[index].pc.video_url && activeIndex === index ? styles.activeprogressbar : ''}`}></div>

                  <div className="h-[50px] leading-[50px]">{item?.tab_title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 top-0 ml-[48px] hidden text-white group-hover:block">
          <div className="flex h-full items-center justify-center">
            <button
              className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-black/40 transition-colors duration-200 hover:bg-black/30 focus:bg-black/65 focus:outline-none active:bg-black/65"
              onClick={handlePrev}
              onMouseLeave={(e) => e.currentTarget.blur()}>
              <Arrow width={20} height={20} rotate={180} color="currentColor" />
            </button>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 top-0 mr-[48px] hidden text-white group-hover:block">
          <div className="flex h-full items-center justify-center">
            <button
              className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-black/40 transition-colors duration-200 hover:bg-black/30 focus:bg-black/65 focus:outline-none active:bg-black/65"
              onClick={handleNext}
              onMouseLeave={(e) => e.currentTarget.blur()}>
              <Arrow width={20} height={20} color="currentColor" />
            </button>
          </div>
        </div>
      </div>
    )
  }

  const renderMdBanner = () => {
    return (
      <div
        className={`group relative mt-[-53px] max-xl:mt-[-40px]`}
        // onMouseEnter={() => handleBannerHover()}
        // onMouseLeave={() => handleBannerLeave()}
      >
        <Splide
          ref={carouselRef1}
          options={{
            type: 'loop',
            // autoplay: true,
            pagination: !1,
            drag: !1,
            arrows: !1,
            rewind: !0,
            perMove: 1,
            // lazyLoad: "nearby",
            preloadPages: 2,
            interval: 5000,
          }}
          onMove={(e: object, a: number) => {
            stopDotsAnimation()
            setBannerIndex(a)
            handleSideChange(a)
          }}>
          {blockData.items.map((_, index) => (
            <SplideSlide
              key={index}
              onMouseEnter={() => {
                stopDotsAnimation()
              }}
              onMouseLeave={() => {
                playDotsAnimation(index)
              }}>
              <Link href={_.pc.link}>
                <div className="relative h-[700px] w-full pt-[41.4583%]">
                  <div className="absolute top-0 flex h-full w-full flex-col items-center">
                    {_?.pc?.video_url ? (
                      <video
                        ref={(ele) => {
                          if (ele) {
                            videoListRef.current[index] = ele
                          }
                        }}
                        poster={_?.pc?.image}
                        autoPlay={index === 0}
                        src={_?.pc?.video_url}
                        playsInline
                        muted
                        preload="auto"
                        controlsList="nopictureinpicture"
                        onLoadedMetadata={() => {
                          if (index === 0) {
                            setFirstVideoLoad(true)
                          }
                        }}
                        onEnded={(e) => {
                          ;(e.target as HTMLVideoElement).currentTime = 0
                        }}
                        className="absolute h-[100%] w-[100%] object-cover"></video>
                    ) : (
                      <Image
                        src={_?.mob?.pad_image ?? _?.pc?.image}
                        alt={_?.pc?.image_alt}
                        fill
                        priority
                        className="h-[700px] w-full object-cover"
                      />
                    )}
                    <div className="mt-[60.08px]">
                      {/* 主内容 */}
                      <div className="relative flex w-[1000px] flex-col items-center gap-y-[25px] text-center text-white">
                        {_?.pc?.subtitle && (
                          <div
                            className="text-subtitle w-full overflow-hidden text-ellipsis whitespace-nowrap text-[20px]"
                            style={{ color: _?.pc?.subtitle_color }}
                            title={_?.pc?.subtitle}>
                            {_?.pc?.subtitle}
                          </div>
                        )}
                        {_?.pc?.title && (
                          <div
                            className="text-title w-full overflow-hidden text-ellipsis whitespace-nowrap text-[64px] leading-[77px] max-xl:text-[40px] max-xl:leading-[48px]"
                            style={{ color: _?.pc?.title_color }}
                            title={_?.pc?.title}>
                            {_?.pc?.title}
                          </div>
                        )}
                        {_?.pc?.title_image && (
                          <div className="w-full text-center">
                            <Image
                              src={_?.pc?.title_image}
                              alt={_?.pc?.title || 'Banner title'}
                              className="inline-block h-full w-full max-w-[392px] object-contain"
                              style={{ height: 'auto' }}
                              width={0}
                              height={0}
                              unoptimized
                              sizes="100vw"
                            />
                          </div>
                        )}
                        {_?.pc?.content && (
                          <div
                            className="text-description mb-4 w-full text-[28px] leading-[32px] max-xl:text-[16px] max-xl:leading-[22px]"
                            style={{ color: _?.pc?.content_color }}>
                            {_?.pc?.content}
                          </div>
                        )}
                        {_?.pc?.show_button == '1' ? (
                          <BannerButton data={_?.pc}>
                            <span>{_?.pc?.button_text}</span>
                          </BannerButton>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </SplideSlide>
          ))}
        </Splide>
        {/* 选项卡 */}
        <div className="absolute bottom-0 left-0 h-[100px] w-full bg-[linear-gradient(360deg,rgba(0,0,0,0.5)_-71.82%,rgba(0,0,0,0)_88.64%)]">
          <div className="mx-auto flex w-fit justify-center">
            <div className="flex h-fit items-center justify-center text-[16px] text-white">
              {blockData?.items.map((item, index) => (
                <div
                  key={index}
                  className={`relative flex min-w-[140px] items-center justify-center px-[20px] pt-[15px] text-white ${activeIndex === index ? 'font-miSansSemiBold520 text-opacity-100' : 'text-opacity-60'} cursor-pointer border-t border-gray-4 text-[18px]`}
                  onClick={() => {
                    handleClickDot(index)
                  }}>
                  {/* activeprogressbar: 图片进度条动画 */}
                  <div
                    className={`progressLine absolute left-0 top-[-1px] h-[1px] w-0 bg-white ${!blockData.items[index].pc.video_url && activeIndex === index ? styles.activeprogressbar : ''}`}></div>

                  <div className="h-[50px] leading-[50px]">{item?.tab_title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 top-0 ml-[48px] text-white">
          <div className="flex h-full items-center justify-center">
            <button
              className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-black/40 transition-colors duration-200 hover:bg-black/30 focus:bg-black/65 focus:outline-none focus-visible:bg-black/65 active:bg-black/65"
              onClick={handlePrev}
              onMouseLeave={(e) => e.currentTarget.blur()}>
              <Arrow width={20} height={20} rotate={180} color="currentColor" />
            </button>
          </div>
        </div>
        <div className="absolute bottom-0 right-0 top-0 mr-[48px] text-white">
          <div className="flex h-full items-center justify-center">
            <button
              className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-black/40 transition-colors duration-200 hover:bg-black/30 focus:bg-black/65 focus:outline-none focus-visible:bg-black/65 active:bg-black/65"
              onClick={handleNext}
              onMouseLeave={(e) => e.currentTarget.blur()}>
              <Arrow width={20} height={20} color="currentColor" />
            </button>
          </div>
        </div>
      </div>
    )
  }

  const renderMobileBanner = () => {
    return (
      <div className="relative mt-[-53px] max-xl:mt-[-40px]">
        <Carousel
          autoPlay={autoPlay ? true : false}
          loop={true}
          interval={5000}
          showIndicators={true}
          indicatorsContainerClassName="bottom-[15px]"
          indicatorsItemClassName="h-[6px] w-[6px] bg-[#FFFFFF73]"
          indicatorsActiveItemClassName="w-[34px] h-[6px] bg-[#FFFFFFD9]"
          showArrows={false}
          // onSlideChange={handleSideChange}
        >
          {blockData?.items.map((_, index) => (
            <CarouselItem key={index}>
              <Link href={_.mob.link}>
                <div className="relative h-0 w-full pt-[160%]">
                  <div className="absolute top-0 flex h-full w-full flex-col items-center bg-black">
                    {_?.mob?.video_url ? (
                      <video
                        ref={(ele) => {
                          if (ele) {
                            videoListRef.current[index] = ele
                          }
                        }}
                        autoPlay={index === 0}
                        src={_?.mob?.video_url}
                        playsInline
                        controlsList="nopictureinpicture"
                        muted
                        onEnded={() => {
                          setAutoPlay(true)
                        }}
                        className="absolute left-1/2 top-1/2 max-h-full max-w-full translate-x-[-50%] translate-y-[-50%] object-cover"></video>
                    ) : (
                      <Image src={_?.mob?.image} alt={_?.mob?.image_alt} fill />
                    )}
                    <div className="mt-[127.5px] max-xl:mt-[64px]">
                      {/* 主内容 */}
                      <div className="relative flex flex-col items-center gap-y-2 text-center text-white">
                        {_?.mob?.subtitle && (
                          <div
                            className="text-subtitle flex h-[28px] items-center justify-center text-[20px]"
                            style={{ color: _?.mob?.subtitle_color }}>
                            {_?.mob?.subtitle}
                          </div>
                        )}
                        {_?.mob?.title && (
                          <div
                            className="text-title flex items-center justify-center text-[64px] leading-[77px] max-xl:text-[40px] max-xl:leading-[48px]"
                            style={{ color: _?.mob?.title_color }}>
                            {_?.mob?.title}
                          </div>
                        )}
                        {_?.mob?.title_image && (
                          <div className="flex w-full justify-center">
                            <Image
                              src={_?.mob?.title_image}
                              alt={_?.mob?.title || 'Banner title'}
                              className="h-full w-full max-w-[640px] object-contain"
                              style={{ height: 'auto' }}
                              width={0}
                              height={0}
                              unoptimized
                              sizes="100vw"
                            />
                          </div>
                        )}
                        <div
                          className="text-description mb-4 flex items-center justify-center text-[24px] leading-[32px] max-xl:text-[16px] max-xl:leading-[22px]"
                          style={{ color: _?.mob?.content_color }}>
                          {_?.mob?.content}
                        </div>
                      </div>
                    </div>
                    {_?.mob?.show_button == '1' ? (
                      <Button
                        size="lg"
                        asChild
                        className="absolute bottom-[48px] py-[12px] pl-[24px] pr-[17px] text-[16px]"
                        style={{
                          color: _?.mob?.button_text_color,
                          backgroundColor: _?.mob?.button_background_color,
                        }}>
                        <span>
                          {_?.mob?.button_text}
                          <Arrow width={20} height={20} color="#fff" />
                        </span>
                      </Button>
                    ) : null}
                  </div>
                </div>
              </Link>
            </CarouselItem>
          ))}
        </Carousel>
      </div>
    )
  }

  // return blockData?.items.length > 0
  // ? isXlScreen || isMdScreen
  //   ? renderXlBanner()
  //   : renderMobileBanner()
  // : null

  return blockData?.items.length > 0
    ? isXlScreen
      ? renderXlBanner()
      : isMdScreen
        ? renderMdBanner()
        : renderMobileBanner()
    : null
}
